import { gql } from '@apollo/client';
import { DiagnosisFragment } from '@/shared/api';

const STUDY_DETAILS_DRAWER_QUERY = gql`
  query study($id: ID!) {
    study(id: $id) {
      id
      friendlyId
      onboarding {
        pacer
        icd
      }
      info {
        patient {
          dob
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          duration
          studyType
          reportDueDate
        }
      }
      initDuration
      start
      stop
      studyType
      status
      reportDueDate
      rma
      artifact {
        percentage
      }
      studyNote
      timezone
      facility {
        id
        name
        contact {
          country
        }
        notificationEmail
        timezone
      }
      device {
        id
        deviceId
        model
        firstStudyDate
      }
      linkedStudies {
        friendlyId
        initDuration
        studyType
        reportDueDate
        id
      }
      ecgDetail
      patientAge
      isAFibDetected
      hasAFibCode
    }
  }

  ${DiagnosisFragment}
`;

export default STUDY_DETAILS_DRAWER_QUERY;
